import { kAvailableIconNames, kCardColors } from './testConfigConstants';

export const kTestCategoryStatuses = ['active', 'inactive', 'archived'] as const;

export const kDefaultItemsName = 'report';

export const kItemsNameExamples = ['report', 'trends', 'charts'] as const;

export { kAvailableIconNames, kCardColors };
